var _rect, _rect2, _text, _text2, _rect3, _circle, _text3, _text4, _rect4, _circle2, _text5, _text6, _rect5, _circle3, _text7, _text8, _rect6, _circle4, _text9, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreImplementationResponsibleIntelligenceFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 760,
    height: 340,
    viewBox: "0 0 760 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore responsible intelligence framework") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 340,
    rx: 28,
    fill: "#07152A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 758,
    height: 338,
    rx: 27,
    fill: "none",
    stroke: "#284260",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 43,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 1.7
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    dy: 0
  }, "RESPONSIBLE INTELLIGENCE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 80,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    dy: 0
  }, "AI supports the review. People own the decision."))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 112,
    width: 330,
    height: 76,
    rx: 15,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 137,
    r: 6,
    fill: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 142,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Evidence led")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 168,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "Original records remain available")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 112,
    width: 330,
    height: 76,
    rx: 15,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 137,
    r: 6,
    fill: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 142,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Configured thresholds")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 168,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "Context determines exceptions")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 208,
    width: 330,
    height: 76,
    rx: 15,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 233,
    r: 6,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 238,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Human review")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 264,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "People retain responsibility")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 208,
    width: 330,
    height: 76,
    rx: 15,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 233,
    r: 6,
    fill: "#FF2775"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 238,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Audit trail")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 264,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "Actions remain attributable")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreImplementationResponsibleIntelligenceFramework);
export default __webpack_public_path__ + "static/media/fleetcore-implementation-responsible-intelligence-framework.f6b24eae47c0b13d5e72e74a76537466.svg";
export { ForwardRef as ReactComponent };